let Cookies = require('../vendor/js.cookie');

/**
 * Header
 * ------
 */

if($('.gform_wrapper').length) {

    let gfields = $('.gfield');

    gfields.each(function () {

        let container = $(this),
            label = $(this).find('label').first(),
            input = $(this).find('input').first(),
            textarea = $(this).find('textarea').first(),
            select = $(this).find('select').first();

        if(label.length) {
            label.on('click', function () {
                // container.addClass('focus');
            });
        }

        if(input.length) {
            if(input.parent().hasClass('name_first')) {
                container.addClass('is-name-field');
            } else if(container.find('.ginput_container_address').length) {
                container.addClass('is-address-field');
            } else if(input.attr('type') === "text") {
                container.addClass('floated-label');

                input.on('focus', function () {
                    container.addClass('focus');
                });

                input.on('focusout', function () {
                    if($(this).val() == "") {
                        container.removeClass('focus');
                    }
                });
            } else if(input.attr('type') === "radio") {
                container.addClass('has-radio-buttons');
            } else if(input.attr('type') === "checkbox") {
                container.addClass('has-checkboxes');
            }
        }

        if(textarea.length) {
            container.addClass('floated-label');

            textarea.on('focus', function () {
                container.addClass('focus');
            });

            textarea.on('focusout', function () {
                if($(this).val() == "") {
                    container.removeClass('focus');
                }
            });
        }

        if(select.length) {
            container.addClass('has-select');
        }

    });

}